import { request } from "../network/request";
const db = "dn0";


export function getMenuList(params) {
    return request({
        url: "course/menuList",
        method: "get",
        params,
    });
}

// ------------------首页----------------------
/**
 * 课题研究时间表
 * @param {*}  
 * @returns 
 */
export function getStudyTimeList(params) {
    return request({
        url: "course/courseIndex/studyTimeList",
        method: "get",
        params,
    });
}
/**
 * 院内课题成果评分表
 * @param {*} params 
 * @returns 
 */
export function getResultScoreList(params) {
    return request({
        url: "course/courseIndex/resultScoreList",
        method: "get",
        params,
    });
}
/**
 * 课题追踪月报反馈情况
 * @param {*} params 
 * @returns 
 */
export function getFeedbackList(params) {
    return request({
        url: "course/courseIndex/feedbackList",
        method: "get",
        params,
    });
}
/**
 * 课题所在部门占比
 * @param {*} params 
 * @returns 
 */
export function getDeptChart(params) {
    return request({
        url: "course/courseIndex/deptChart",
        method: "get",
        params,
    });
}
/**
 * 课题概况
 * @param {*} params 
 * @returns 
 */
export function getCourseBasic(params) {
    return request({
        url: "course/courseIndex/courseBasic",
        method: "get",
        params,
    });
}

export function getExcellentCgList(params) {
    return request({
        url: "course/courseIndex/excellentCgList",
        method: "get",
        params,
    });
}
/**
 * 课题列表查询条件获取
 * @param {*} params
 * @returns
 */
export function getCourseQueryCondition(params) {
    return request({
        url: "course/courseIndex/queryCondition",
        method: "get",
        params,
    });
}
/**
 * 课题列表与我相关统计
 * @param {*} params
 * @returns
 */
export function getCourseSum() {
    return request({
        url: "course/courseIndex/courseSum",
        method: "get"
    });
}
/**
 * 课题列表查询
 * @param {*} params
 * @returns
 */
export function getCourseList(params) {
    return request({
        url: "course/courseIndex/courseList",
        method: "get",
        params,
    });
}
/**
 * 课题列表导出
 * @param {*} params
 * @returns
 */
export function exportCourse(params) {
    return request({
        url: "course/courseIndex/exportCourseList",
        method: "get",
        params,
    });
}

/**
 * 课题录入
 * @param {*} params 
 * @returns 
 */
export function addCourse(params) {
    return request({
        url: "course/addCourse",
        method: "post",
        data: params,
    });
}
/**--------------------立项申请----------------- */
/**
 * 立项申请结果页
 * @param {*} params 
 * @returns 
 */
export function getItemApplyList(params) {
    return request({
        url: "course/getItemApplyList",
        method: "get",
        params,
    });
}
/**
 * 立项申请表单 获取成员信息
 * @param {*} params 
 * @returns 
 */
export function getMemberByYgbh(params) {
    return request({
        url: "course/getMemberByYgbh",
        method: "get",
        params,
    });
}
/**
 * 立项申请结果页-成员保存 （新增，编辑）
 * @param {*} params 
 * @returns 
 */
export function saveCourseMember(params) {
    return request({
        url: "course/saveCourseMember",
        method: "post",
        data: params,
    });
}
/**
 * 立项申请结果页-成员删除
 * @param {*} params 
 * @returns 
 */
export function deleteMemberById(params) {
    return request({
        url: "course/deleteMemberById",
        method: "get",
        params,
    });
}
/**
 * 获取立项申请表信息
 * @param {*} params 
 * @returns 
 */
export function getItemApply(params) {
    return request({
        url: "course/getItemApply",
        method: "get",
        params,
    });
}
/**
 * 保存立项申请
 * @param {*} params 
 * @returns 
 */
export function insertItemApply(params) {
    return request({
        url: "course/insertItemApply",
        method: "post",
        data: params,
    });
}
/**
 * 
 * @param {*} params 
 * @returns 
 */
export function listUnfinishFeedback(params) {
    return request({
        url: "course/listUnfinishFeedback",
        method: "get",
        params,
    });
}


/**
 * 立项申请结果页-成员列表
 * @param {*} params 
 * @returns 
 */
export function getListCourseMember(params) {
    return request({
        url: "course/listCourseMember",
        method: "get",
        params,
    });
}


/**--------------------立项评审----------------- */
/**
 * 获取评委委员列表
 * @param {*} params 
 * @returns 
 */
export function getlistReviewer(params) {
    return request({
        url: "course/approvalReview/listReviewer",
        method: "get",
        params,
    });
}
/**
 *  获取评审委员的评审信息 
 * @param {*} params 
 * @returns 
 */
export function getApprovalReviewByReviewer(params) {
    return request({
        url: "course/approvalReview/getApprovalReviewByReviewer",
        method: "get",
        params,
    });
}
/**
 *  查询各个阶段评分标准 
 * @param {*} params 
 * @returns 
 */
export function getScoringCriteria(params) {
    return request({
        url: "course/approvalReview/getScoringCriteria",
        method: "get",
        params,
    });
}
/**
 * 立项评审录入 (二次评审录入)
 * @param {*} params 
 * @returns 
 */
export function insertApprovalReview(params) {
    return request({
        url: "course/approvalReview/insertApprovalReview",
        method: "post",
        data: params,
    });
}
/**
 * 立项评审-结果 
 * @param {*} params 
 * @returns 
 */
export function getApprovalReview(params) {
    return request({
        url: "course/approvalReview/getApprovalReview",
        method: "get",
        params,
    });
}
/**
 * 立项评审-进度 
 * @param {*} params 
 * @returns 
 */
export function getReviewJd(params) {
    return request({
        url: "course/approvalReview/getReviewJd",
        method: "get",
        params,
    });
}
/**
 * 新增管理组检查情况
 * @param {*} params 
 * @returns 
 */
export function insertFeedback(params) {
    return request({
        url: "course/approvalReview/insertFeedback",
        method: "post",
        data: params,
    });
}
/**
 * 编辑管理组检查情况
 * @param {*} params 
 * @returns 
 */
export function editFeedback(params) {
    return request({
        url: "course/approvalReview/editFeedback",
        method: "post",
        data: params,
    });
}
/**
 * 获取管理组检查情况
 * @param {*} params 
 * @returns 
 */
export function getListAllFeedback(params) {
    return request({
        url: "course/approvalReview/listAllFeedback",
        method: "get",
        params,
    });
}


/*-----------------------------------------*/
/**课题结果-中期检查 */

export function getMidCheckResult(params) {
    return request({
        url: "course/midCheck/getMidCheckResult",
        method: "get",
        params,
    });
}

/**
 * 获取管理组检查情况
 * @param {*} params 
 * @returns 
 */
export function getInspection(params) {
    return request({
        url: "course/midCheck/Inspection",
        method: "get",
        params,
    });
}

/**
 * 中期检查情况
 * @param {*} params 
 * @returns 
 */
export function getCourseSituation(params) {
    return request({
        url: "course/midCheck/getCourseSituation",
        method: "get",
        params,
    });
}
/**
 * 删除管理组检查情况
 * @param {*} params 
 * @returns 
 */
export function deleteInspection(params) {
    return request({
        url: "course/midCheck/deleteInspection",
        method: "get",
        params,
    });
}
// 新增管理组检查情况的意见反馈
export function insertInspection(params) {
    return request({
        url: "course/midCheck/insertInspection",
        method: "post",
        data: params,
    });
}
/**
 * 编辑管理组检查情况的意见反馈
 * @param {*} params 
 * @returns 
 */
export function editInspection(params) {
    return request({
        url: "course/midCheck/editInspection",
        method: "post",
        data: params,
    });
}
/**
 *获取中期检查单信息 
 * @param {*} params 
 * @returns 
 */
export function getMidCheckForm(params) {
    return request({
        url: "course/midCheck/getMidCheck",
        method: "get",
        params,
    });
}
/**
 * 删除课题研究进展情况
 * @param {*} params 
 * @returns 
 */
export function delSituation(params) {
    return request({
        url: "course/midCheck/removeSituation",
        method: "get",
        params,
    });
}
/**
 * 添加课题研究进展情况
 * @param {*} params 
 * @returns 
 */
export function addSituation(params) {
    return request({
        url: "course/midCheck/addSituation",
        method: "post",
        data: params,
    });
}

/**
 * 编辑课题研究进展情况
 * @param {*} params 
 * @returns 
 */
export function editSituation(params) {
    return request({
        url: "course/midCheck/editSituation",
        method: "post",
        data: params,
    });
}
// 中期检查单保存
export function insertMidCheck(params) {
    return request({
        url: "course/midCheck/insertMidCheck",
        method: "post",
        data: params,
    });
}
/**
 * 中期检查评审保存
 * @param {*} params 
 * @returns 
 */
export function insertCheckSuggest(params) {
    return request({
        url: "course/midCheck/insertCheckSuggest",
        method: "post",
        data: params,
    });
}

/**
 * 课题阶段配置-时间
 * @param {*} params
 * @returns
 */
export function getCourseProcess(params) {
    return request({
        url: "course/courseIndex/getCourseProcess",
        method: "get",
        params,
    });
}
/**
 * 课题阶段配置-时间
 * @param {*} params
 * @returns
 */
export function stepTimeList(params) {
    return request({
        url: "course/courseIndex/stepTimeList",
        method: "get",
        params,
    });
}
/**
 * 课题阶段配置-时间-编辑查询
 * @param {*} params
 * @returns
 */
export function getStepTimeById(id) {
    return request({
        url: "course/courseIndex/getStepTimeById",
        method: "get",
        params: {
            id
        },
    });
}
/**
 * 课题阶段配置-时间新增编辑
 * @param {*} params
 * @returns
 */
export function stepTimeSave(params) {
    return request({
        url: "course/courseIndex/stepTimeSave",
        method: "get",
        params,
    });
}
/**
 * 课题阶段配置-时间删除
 * @param {*} params
 * @returns
 */
export function stepTimeDel(params) {
    return request({
        url: "course/courseIndex/stepTimeDel",
        method: "get",
        params,
    });
}
/**
 * 课题阶段配置-安排列表
 * @param {*} params
 * @returns
 */
export function arrangeList(params) {
    return request({
        url: "course/courseIndex/arrangeList",
        method: "get",
        params,
    });
}
/**
 * 课题阶段配置-安排导出
 * @param {*} params
 * @returns
 */
export function arrangeExport(params) {
    return request({
        url: "course/courseIndex/arrangeExport",
        method: "get",
        params,
    });
}
/**
 * 课题阶段配置-课题列表
 * @param {*} params
 * @returns
 */
export function assignList(params) {
    return request({
        url: "course/courseIndex/assignList",
        method: "get",
        params,
    });
}
/**
 * 课题阶段配置-分享列表
 * @param {*} params
 * @returns
 */
export function shareList(params) {
    return request({
        url: "course/courseIndex/shareList",
        method: "get",
        params,
    });
}
/**
 * 课题阶段配置-评委安排新增/编辑
 * @param {*} params
 * @returns
 */
export function stepArrangeSave(params) {
    return request({
        url: "course/courseIndex/stepArrangeSave",
        method: "post",
        params,
    });
}
/**
 * 课题阶段配置-时间-编辑查询
 * @param {*} params
 * @returns
 */
export function getStepArrangeById(params) {
    return request({
        url: "course/courseIndex/getStepArrangeById",
        method: "get",
        params,
    });
}
/**
 * 课题阶段配置-分享编辑查询
 * @param {*} params
 * @returns
 */
export function getStepShareById(params) {
    return request({
        url: "course/courseIndex/getStepShareById",
        method: "get",
        params,
    });
}
/**
 * 课题阶段配置-分享编辑
 * @param {*} params
 * @returns
 */
export function stepShareSave(params) {
    return request({
        url: "course/courseIndex/stepShareSave",
        method: "post",
        params,
    });
}
/**
 * 获取撤销请求
 * @param {*} params
 * @returns
 */
export function getCancelApply(params) {
    return request({
        url: "cancelApply/getCancelApply",
        method: "get",
        params,
    });
}
/**
 * 保存撤销请求
 * @param {*} params
 * @returns
 */
export function saveCancelApply(params) {
    return request({
        url: "cancelApply/saveCancelApply",
        method: "post",
        data: params,
    });
}


export function getCourseFileList(courseFileInfo) {
    return request({
        url: "course/file/listCourseFile",
        method: "post",
        data: courseFileInfo
    });
}

export function addRemark(courseFileInfo) {
    return request({
        url: "course/file/addRemark",
        method: "post",
        data: courseFileInfo
    });
}

export function deleteFile(fileId) {
    return request({
        url: "course/file/deleteFile",
        method: "post",
        params: {
            fileId
        },
    });
}
export function addBrowseCount(fileId) {
    return request({
        url: "course/file/addBrowseCount",
        method: "post",
        params: {
            fileId
        },
    });
}
export function addDownloadCount(fileId) {
    return request({
        url: "course/file/addDownloadCount",
        method: "post",
        params: {
            fileId
        },
    });
}

export function toClosingReview(courseId, step) {
    return request({
        url: "course/closing/toClosingReview",
        method: "post",
        params: {
            courseId, step
        },
    });
}




/**--------------------- */
/**
 * 课题统计
 * @param {*} 
 * @returns 
 */
export function getCourseStatistics(params) {
    return request({
        url: "course/courseIndex/getCourseStatistics",
        method: "get",
        params
    });
}

/*--------------结项申请---------------*/
/**
 * 结项申请单信息
 * @param {*} params
 * @returns
 */
export function getCourseJxsqFormInfo(params) {
    return request({
        url: "course/closing/getCourseInfo",
        method: "post",
        params
    });
}


/**
 * 结项申请单新增编辑
 * @param {*} params 
 * @returns 
 */
export function insertClosingInfo(params) {
    return request({
        url: "course/closing/insertClosingInfo",
        method: "post",
        data: params
    });
}
/**
 * 获取结项申请结果页
 * @param {*} params 
 * @returns 
 */
export function getClosingApplyResult(params) {
    return request({
        url: "course/closing/getClosingApplyResult",
        method: "post",
        params
    });
}


/**结项评审结果
 * @param {*} params
 * @returns
 */
export function getCourseClosingResult(params) {
    return request({
        url: "course/closing/closingResultDetails",
        method: "post",
        params
    });
}

/**结项初审、质量评分
 * @param {*} params
 * @returns
 */
export function getClosingMergerResultDetails(params) {
    return request({
        url: "course/closing/closingMergerResultDetails",
        method: "post",
        params
    });
}

/**
 * 获取结项评审表单 
 * @param {*} params 
 * @returns 
 */
export function getCourseClosingReviewInfo(params) {
    return request({
        url: "course/closing/getCourseClosingReviewInfo",
        method: "post",
        params
    });
}
/**
 * 获取结项评审评审委员列表 
 * @param {*} params 
 * @returns 
 */
export function getJxpsListReviewer(params) {
    return request({
        url: "course/closing/listReviewer",
        method: "post",
        params
    });
}

/**
 *  结项评审单新增编辑
 * @param {*} params 
 * @returns 
 */
export function insertClosingReview(params) {
    return request({
        url: "course/closing/insertClosingReview",
        method: "post",
        data: params
    });
}
/**
 * 获取延迟结项表单
 * @param {*} params 
 * @returns 
 */
export function getDelayApplyInfo(params) {
    return request({
        url: "course/closing/getDelayApplyInfo",
        method: "post",
        params
    });
}
/**
 * 延迟结项单新增编辑
 * @param {*} params 
 * @returns 
 */
export function insertDelayApplyInfo(params) {
    return request({
        url: "course/closing/insertDelayApplyInfo",
        method: "post",
        data: params
    });
}

/**
 * 延迟结项结果页
 * @param {*} params 
 * @returns 
 */
export function getDelayClosing(params) {
    return request({
        url: "course/closing/getDelayClosing",
        method: "post",
        params
    });
}
/**
 * 	延迟结项反馈意见新增编辑
 * @param {*} params 
 * @returns 
 */
export function insertClosingFeedback(params) {
    return request({
        url: "course/closing/insertFeedback",
        method: "post",
        data: params
    });
}


/**
 * 获取撤销反馈
 * @param {*} params
 * @returns
 */
export function listAllFeedback(params) {
    return request({
        url: "cancelApply/listAllFeedback",
        method: "get",
        params,
    });
}
/**
 * 保存撤销反馈
 * @param {*} params
 * @returns
 */
export function saveFeedback(params) {
    return request({
        url: "cancelApply/saveFeedback",
        method: "post",
        data: params,
    });

}

/**
 * 取消撤销申请
 * @param {*} params
 * @returns
 */
export function delCancelApply(params) {
    return request({
        url: "cancelApply/delCancelApply",
        method: "get",
        params,
    });
}

/**
 * 取消申请按钮权限
 * @param {*} params
 * @returns
 */
export function isCancelApply(params) {
    return request({
        url: "cancelApply/isCancelApply",
        method: "get",
        params,
    });
}

/**
 * 立项申请导师列表
 * @param {*} params
 * @returns
 */
export function courseJudgesList(params) {
    return request({
        url: "course/courseJudgesList",
        method: "get",
        params,
    });
}


/**--------------------质量评分----------------- */
/**
 * 获取评委委员列表
 * @param {*} params 
 * @returns 
 */
export function getZlpflistReviewer(params) {
    return request({
        url: "course/qualityScore/listReviewer",
        method: "get",
        params,
    });
}
/**
 *  获取评审委员的评审信息 
 * @param {*} params 
 * @returns 
 */
export function getQualityScoreReviewByReviewer(params) {
    return request({
        url: "course/qualityScore/getApprovalReviewByReviewer",
        method: "get",
        params,
    });
}


/**
 * 质量评分录入 
 * @param {*} params 
 * @returns 
 */
export function insertQualityScore(params) {
    return request({
        url: "course/qualityScore/insertQualityScore",
        method: "post",
        data: params,
    });
}

export function getReviewId(params) {
    return request({
        url: "course//approvalReview/listDlrReviewerID",
        method: "get",
        params,
    });
}

